import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { HashRouter, Route, Routes } from 'react-router-dom';
import Inhaltsverzeichnis from './components/inhaltsverzeichnis';
import InhaltsverzeichnisFav from './components/inhaltsverzeichnis_fav';
import InhaltsverzeichnisKateg from './components/inhaltsverzeichnis_kateg';
import LiedDetail from './components/liedseite';
import LiedBearbeiten from './components/liedBearbeiten';
import LiedHinzufuegen from './components/liedHinzufuegen';
import Navbar from './components/navbar';

function App() {
  return (
    <Routes>
      <Route path='/' element={<Inhaltsverzeichnis />} />
      <Route path='/lied/:id' element={<LiedDetail />} />
      <Route path='/favoriten' element={<InhaltsverzeichnisFav />} />
      <Route path='/kategorie' element={<InhaltsverzeichnisKateg />} />
      <Route path='/bearbeiten' element={<LiedBearbeiten />} />
      <Route path='/hinzufuegen' element={<LiedHinzufuegen />} />
    </Routes>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>

    <App />
      <Navbar />
  </HashRouter>
);
